// extracted by mini-css-extract-plugin
module.exports = {"trust-pilot-banner":"TrustPilotBanner_trust-pilot-banner__SKV6G"};